module.exports = {
  businessIntelligenceChartTab: 'BI диаграмма',
  businessIntelligenceDashboardTab: 'BI дашборд',
  chartGroupSettingTab: 'Настройка группировки диаграмм',
  chartConfigurationManagement: 'Управление BI диаграммами арендатора',
  common: {
    query: 'Поиск',
    edit: 'Редактировать',
    save: 'Сохранить',
    cancel: 'Отмена',
    tenantName: 'Название арендатора',
    saveSuccess: 'Сохранено успешно'
  },
  businessIntelligence: {
    searchKeyword: 'Введите ключевое слово для поиска',
    copyChart: 'Копировать диаграммы и дашборды',
    copyAll: 'Копировать для всех арендаторов',
    all: 'Все',
    copyIdRemind: 'Введите ID объекта для копирования',
    copyAllRemind: 'Выберите арендаторов для копирования',
    chartIdPlaceholder: 'Введите ID',
    chart: 'Диаграмма',
    dashboard: 'Дашборд',
    type: 'Тип',
    copyTo: 'Копировать для выбранных арендаторов',
    copyChartId: 'ID объекта копирования',
    openBiChart: 'Активировать BI диаграммы',
    openTenantBiChart: 'Активировать BI диаграммы арендатора',
    selectTenant: 'Выбор арендатора',
    keywords: 'Введите ключевое слово',
    note: 'Примечание',
    chartNumber: 'Редактировать количество диаграмм арендатора',
    tenantId: 'ID арендатора',
    initializeChartNum: 'Доступное количество диаграмм',
    hasBeenUsedChart: 'Использованное количество диаграмм',
    openingDate: 'Дата активации',
    adjustNumber: 'Корректировка количества',
    expirationTime: 'Срок действия',
    selectTime: 'Выберите время',
    adjust1: 'Увеличить',
    adjust2: 'Уменьшить',
    available: 'Доступное количество диаграмм арендатора',
    hasBeenUsed: 'Использованное количество диаграмм арендатора',
    noteInformation: 'Информация примечания',
    saveWarning: 'Выберите арендатора',
    saveSuccess: 'Активация успешна',
    copySuccess: 'Копирование успешно',
    editWarning: 'Заполните корректировку количества',
    editWarningTime: 'Укажите срок действия',
    editSuccess: 'Сохранено успешно',
    adjustQuantity1: 'Корректировка количества не может быть отрицательной',
    adjustQuantity2: 'Уменьшение количества не может превышать текущее число диаграмм'
  },
  businessIntelligenceChart: {
    myChartNum: 'Мои диаграммы',
    addChart: 'Добавить пользовательскую диаграмму',
    queryChart: 'Поиск моих диаграмм',
    standardChart: 'Библиотека стандартных шаблонов BI-диаграмм (выберите нужную диаграмму)',
    queryStandardChart: 'Поиск шаблонов диаграмм',
    chartTemplate: 'Шаблон диаграммы:',
    classification: 'Категория:',
    chartName: 'Название диаграммы',
    chartGrouping: 'Группа диаграмм',
    chartId: 'ID диаграммы',
    remark: 'Примечание',
    editChart: 'Редактировать пользовательскую диаграмму',
    selectAll: 'Все',
    hasChosen: 'Выбрано',
    notChoose: 'Не выбрано',
    chartNamePrompt: 'Введите название диаграммы',
    chartIdPrompt: 'Введите ID диаграммы',
    addSuccess: 'Успешно добавлено',
    deleteSuccess: 'Успешно удалено',
    warmPrompt: 'Доброе напоминание',
    warmPromptStatements: 'Уважаемый арендатор, вы достигли лимита использования диаграмм (${0} шт.). Если вам нужно увеличить количество доступных диаграмм, свяжитесь с онлайн-службой поддержки WallTech или позвоните по номеру 021-65143931.',
    confirmButtonText: 'Понятно'
  },
  chartGroupSetting: {
    viewChart: 'Просмотреть диаграмму',
    newGrouping: 'Создать группу',
    delete: 'Удалить',
    order: 'Порядковый номер',
    groupName: 'Название группы',
    groupNameTips: 'Название группы должно быть уникальным',
    remark: 'Примечание',
    selectGrouping: 'Выберите диаграммы для добавления в группу',
    queryChartName: 'Поиск по названию диаграммы',
    eidtChart: 'Редактировать диаграмму',
    currentGrouping: 'Текущая группа',
    chartDescription: 'Описание диаграммы',
    addGroup: 'Добавить группу',
    editGroup: 'Редактировать группу',
    rankRemind: 'Укажите порядковый номер группы',
    groupingNameRemind: 'Укажите название группы',
    chartNameRemind: 'Укажите название диаграммы',
    chartGrouping: 'Выберите группу диаграмм',
    deleteSuccess: 'Успешно удалено'
  },
  businessIntelligenceDashboard: {
    addDashboard: 'Добавить дашборд',
    delete: 'Удалить',
    fullScreen: 'Полноэкранный режим',
    setFilter: 'Настройка фильтров',
    preview: 'Предпросмотр',
    saveLayout: 'Сохранить макет',
    dragTips: 'Вы можете изменять положение и размер диаграмм перетаскиванием.',
    addChart: 'Добавить диаграмму',
    dashboardType: 'Тип дашборда',
    customizeDashboard: 'Пользовательский дашборд',
    biDashboard: 'BI-дашборд',
    dashboardName: 'Название панели',
    dashboardId: 'ID панели',
    dashboardNamePlaceholder: 'Введите название панели',
    classification: 'Категория панели',
    biDashboardId: 'ID панели BI',
    biDashboardIdPlaceholder: 'Введите ID панели',
    Notes: 'Примечание',
    setAccessRights: 'Настройка прав доступа',
    selectBranch: 'Выбор филиала',
    selectBranchPlaceholder: 'Выберите компанию',
    selectDepartment: 'Выбор отдела',
    selectDepartmentPlaceholder: 'Выберите отдел',
    selectPersonnel: 'Выбор сотрудника',
    selectPersonnelPlaceholder: 'Выберите сотрудника',
    setDataPermission: 'Настройка прав доступа к данным',
    whole: 'Просмотр всех данных',
    company: 'Просмотр данных филиала',
    department: 'Просмотр данных отдела',
    personal: 'Только личные данные',
    rolePermissions: 'Просмотр данных по ролевым правам',
    chartAddDashboard: 'Выбор диаграммы для добавления на панель',
    queryChartName: 'Поиск по названию диаграммы',
    add: 'Добавить',
    seePreview: '*Нажмите для предпросмотра',
    determine: 'Подтвердить',
    setQueryItem: 'Настройка параметров запроса панели',
    grouping: 'Группировка',
    businessDashboard: 'Бизнес-панель',
    financialDashboard: 'Финансовая панель',
    deleteConfirm: 'Удалить эту панель?',
    tips: 'Подсказка',
    saveTips: 'Выберите диаграмму для добавления на панель',
    saveTips1: 'Название панели должно быть уникальным',
    prompt1: 'Настройте права доступа к панели, например: Шанхайский филиал, Операционный отдел, Чжан Сан.',
    prompt2: 'Если указан только филиал, доступ будут иметь все его сотрудники.',
    prompt3: 'Права доступа к данным ограничивают видимость информации для текущего пользователя.',
    prompt4: 'Например: "Только личные" — доступ только к своим данным.',
    prompt5: 'Подробнее у онлайн-поддержки WallTech или по телефону 021-65143931.',
    prompt6: 'Уважаемый клиент, для получения информации о BI-приложениях обратитесь в онлайн-поддержку WallTech или по телефону 021-65143931.'
  }
}
